import { Icon, Progress, Tag } from 'antd';
import styled from 'styled-components';

export const Container = styled.div`
  font-family: 'Roboto';
  user-select: none;
  margin: 0 0 8px 0;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  background: ${({ isRevised }) => isRevised ? '#e8f5e8' : '#ffffff'};
  border: 1px solid #e8e8e8;
  transition: all 0.2s ease;
  cursor: pointer;
  height: 80px;
  display: flex;
  flex-direction: column;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
    transform: translateY(-2px);
    border-color: #d9d9d9;
  }

  ${({ isDragging }) => isDragging && `
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    transform: scale(1.02);
    border-color: #1890ff;
  `}
`;

export const LeftTopContent = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 6px;
  position: absolute;
  left: 0;
  top: 0;
`;

export const RightTopContent = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 6px;
  position: absolute;
  right: 5px;
  top: 0;
`;

export const SourceIconContainer = styled.div`
  background-color: #595959;
  padding: 1px 8px;
  border-radius: 6.25px 0px;
`;

export const Content = styled.div`
  margin: 8px;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

export const MainContent = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  flex: 1;
  min-height: 0;
`;

export const LeadInfo = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
`;

export const DateContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  margin-bottom: 4px;
  color: #666;
  font-size: 10px;
  background: #fafafa;
  padding: 1px 4px;
  border-radius: 4px;
  width: fit-content;
`;

export const CalendarIcon = styled(Icon).attrs({
  type: 'calendar',
  style: {
    color: '#666',
    fontSize: '10px',
  },
})``;

export const Date = styled.span`
  font-size: 10px;
  color: #666;
`;

export const CopyButton = styled.button`
  cursor: pointer;
  border: 0;
  background-color: transparent;
  position: absolute;
  padding: 0;
  right: 8px;
  top: 8px;
  opacity: 0.6;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 1;
  }
`;

export const CopyIcon = styled(Icon).attrs({
  type: 'copy',
  style: {
    color: '#666',
  },
})``;

export const LeadName = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: #333;
  display: block;
  margin-bottom: 4px;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 24px;

  .anticon {
    margin-right: 4px;
    color: #666;
    font-size: 12px;
  }
`;

export const Value = styled.span`
  color: #118632;
  font-size: 12px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  margin-top: 2px;
  background: rgba(17, 134, 50, 0.1);
  padding: 1px 6px;
  border-radius: 4px;
  width: fit-content;

  &::before {
    content: 'R$';
    margin-right: 2px;
    font-size: 10px;
    opacity: 0.8;
  }
`;

export const RTName = styled.span`
  font-size: 10px;
  color: #666;
  display: block;
  margin-top: 1px;
`;

export const CadenceContainer = styled.div`
  margin-top: auto;
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  padding-top: 4px;
  border-top: 1px solid #f0f0f0;

  .ant-tag {
    margin: 0 !important;
    height: 3px !important;
    line-height: 1px !important;
    padding: 0 !important;
    font-size: 0 !important;
    border-radius: 2px !important;
    min-width: 12px !important;
  }
`;

export const SourceTag = styled(Tag)`
  margin-top: 4px !important;
  border-radius: 4px !important;
  padding: 0 4px !important;
  font-size: 10px !important;
  background: rgba(24, 144, 255, 0.1) !important;
  border: none !important;
  color: #1890ff !important;
`;

export const PriorityIndicator = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 2px;
  height: 100%;
  background: ${({ priority }) => {
    switch (priority) {
      case 'high':
        return '#ff4d4f';
      case 'medium':
        return '#faad14';
      case 'low':
        return '#52c41a';
      default:
        return 'transparent';
    }
  }};
`;